var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarningsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.495,
    height: 17.498,
    viewBox: "0 0 17.495 17.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16774",
    "data-name": "Rectangle 16774",
    width: 17.495,
    height: 17.498,
    fill: "#1ebcc2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16665",
    "data-name": "Group 16665",
    transform: "translate(4752 728.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16608",
    "data-name": "Group 16608",
    transform: "translate(-4752 -728.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16607",
    "data-name": "Group 16607",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41427",
    "data-name": "Path 41427",
    d: "M75.966,94.607c.34-.533.639-1.029.965-1.507a15.757,15.757,0,0,1,2.1-2.487.4.4,0,0,1,.249-.1c.585-.009,1.171,0,1.771,0a2.638,2.638,0,0,1-.114.916,3.059,3.059,0,0,1-.739,1.271.509.509,0,0,0,.233.873.483.483,0,0,0,.506-.17c.219-.26.427-.529.646-.8.019.027.046.067.076.105.177.23.344.467.534.685a.511.511,0,1,0,.747-.694A3.018,3.018,0,0,1,82.1,90.9c-.014-.123-.014-.248-.021-.384.063,0,.112-.01.161-.01.53,0,1.059,0,1.589,0a.324.324,0,0,1,.21.074,17.221,17.221,0,0,1,3.7,5.341,5.882,5.882,0,0,1,.525,2.194,3.116,3.116,0,0,1-2.287,3.255,7.727,7.727,0,0,1-2.175.4c-.6.028-1.194.006-1.748.006.009-.5.024-1.016.026-1.536,0-1.333,0-2.665,0-4a1.54,1.54,0,0,0-1.633-1.64H75.966",
    transform: "translate(-70.774 -84.32)",
    fill: "#1ebcc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41428",
    "data-name": "Path 41428",
    d: "M5.14,165.519H9.683a.53.53,0,0,1,.6.608q0,2.485,0,4.97a.53.53,0,0,1-.6.607H.613c-.421,0-.612-.193-.612-.617q0-2.476,0-4.953c0-.423.191-.616.613-.616H5.14m.014,4.613a1.537,1.537,0,1,0-1.53-1.553,1.541,1.541,0,0,0,1.53,1.553m-3.06-1.025a.512.512,0,1,0-.519-.5.518.518,0,0,0,.519.5m5.632-.536a.512.512,0,1,0,.536-.486.519.519,0,0,0-.536.486",
    transform: "translate(0 -154.207)",
    fill: "#1ebcc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41429",
    "data-name": "Path 41429",
    d: "M109.065.74c.2-.149.406-.314.626-.453a1.6,1.6,0,0,1,1.759-.039,3.724,3.724,0,0,1,1.088.973.5.5,0,0,1,.052.562q-.813,1.644-1.63,3.286a.206.206,0,0,1-.155.09q-1.742.008-3.485,0a.222.222,0,0,1-.162-.1c-.542-1.083-1.078-2.169-1.615-3.255a.491.491,0,0,1,.027-.548,3.422,3.422,0,0,1,1.32-1.107,1.537,1.537,0,0,1,1.5.118c.237.143.453.32.675.48",
    transform: "translate(-98.264 0)",
    fill: "#1ebcc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41430",
    "data-name": "Path 41430",
    d: "M68.524,204.05a.512.512,0,1,1,.51-.51.518.518,0,0,1-.51.51",
    transform: "translate(-63.361 -189.15)",
    fill: "#1ebcc2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningsIcon);
export default __webpack_public_path__ + "static/media/earnings_icon.fa21340d818cd65b9fc25a751c0eb03e.svg";
export { ForwardRef as ReactComponent };